module.exports = __webpack_public_path__ + "img/doub_doublooncoin.cfefeba.png";